function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m1.4 0c-.7735 0-1.4.6265-1.4 1.4v8.4c0 .7735.6265 1.4 1.4 1.4h11.2c.7735 0 1.4-.6265 1.4-1.4v-8.4c0-.7735-.6265-1.4-1.4-1.4zm0 1.4h11.2v8.4h-11.2zm9.1 1.75-1.05 1.05 1.05 1.05 1.05-1.05zm-7.7.35v1.4h4.9v-1.4zm7.7 3.15-1.05 1.05 1.05 1.05 1.05-1.05zm-7.7.35v1.4h3.5v-1.4z"
});

var SvgForm = function SvgForm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 14 12",
    width: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/form.f13bd001.svg";
export { ForwardRef as ReactComponent };